import { Icon } from "@circle-react-shared/Icon";
import { useLiveRoom } from "@circle-react/components/LiveStreams/hooks";
import { useConfirmModal } from "@circle-react/components/LiveStreams/Room/hooks/useConfirmModal";
import { roomTypeData } from "@circle-react/helpers/liveStreamRoomHelpers";
import { Avatar } from "@circleco/compass/components/Avatar";
import { Button } from "@circleco/compass/components/Button";
import { Typography } from "@circleco/compass/components/Typography";

import { t } from "@/i18n-js/instance";

export const LiveIndicator = () => {
  const { room, canManage, handleNavigateToRoom, handleEndStream } =
    useLiveRoom();

  const { confirmModal, onConfirmButtonClick } = useConfirmModal({
    title: t(`live_streams.${roomTypeData(room)}_ended.confirm`),
    onConfirm: handleEndStream,
  });

  if (!room) {
    return null;
  }

  return (
    <div className="bg-c-sidebar w-full p-2 pb-3">
      <div className="bg-sidebar-footer-live-indicator rounded-lg p-4 text-grey-50">
        <div className="mb-2 flex items-center justify-between">
          <div className="flex min-w-0 items-center gap-2">
            <Avatar
              src={room.creator?.avatar_url}
              name={room.creator?.name ?? ""}
              size="sm"
            />
            <Typography
              variant="body-sm"
              color="current"
              className="max-w-[15ch] truncate"
            >
              {room.creator?.name}
            </Typography>
            <Icon type="24-live-waveform" size={24} />
          </div>
          <div className="bg-c-sidebar-badge flex shrink-0 items-center justify-center rounded px-2 py-1">
            <span className="text-xs font-bold uppercase leading-3 text-white">
              {t("sidebar_footer_v3.live")}
            </span>
          </div>
        </div>
        <Typography variant="label-md" color="current" className="line-clamp-2">
          {room.name}
        </Typography>
        <Button
          variant="secondary"
          fullWidth
          className="mt-4"
          onClick={handleNavigateToRoom}
        >
          {t("sidebar_footer_v3.join")}
        </Button>
        {canManage && (
          <div className="mt-2 flex items-center gap-1">
            <Typography variant="label-xs" color="current" component="span">
              {t("live_streams.room.cant_join")}
            </Typography>
            <button
              type="button"
              className="cursor-pointer text-xs font-semibold text-white"
              onClick={onConfirmButtonClick}
            >
              {t(`live_streams.room.${roomTypeData(room)}.end`)}
            </button>
          </div>
        )}
        {confirmModal}
      </div>
    </div>
  );
};
